export default {
  okText: 'ÐÐº',
  cancelText: 'ÐÑÐ¼ÐµÐ½Ð°',
};
